import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query IsAuthed {
    isAuthed
  }
`

export const isAuthedKey = getQueryNames(query)[0]

export default query
